import { useMemo } from "react";
import { InputComboBoxList } from "src/framework/components/forms/inputs/InputComboBoxList"
import { FormProjetoHibridoType } from "src/store/vendas/projetos/hibrido/hibrido.types";
import { InputPrefix } from "./InputPrefix"

interface TipoLigacaoInputProps {
  errorState: string[];
  formState: FormProjetoHibridoType;
  onChangeValue: (formState: Partial<FormProjetoHibridoType>) => void;
}

export const TIPO_LIGACAO_OPTIONS = [
  {
    id: 1,
    nome: 'Monofásico'
  },
  // {
  //   id: 2,
  //   nome: 'Bifásico'
  // },
  // {
  //   id: 3,
  //   nome: 'Trifásico'
  // }
]

export const TipoLigacaoInput = ({ errorState, formState, onChangeValue }: TipoLigacaoInputProps) => {
  return (
    <InputComboBoxList
      id={"hibrido-tipo-ligacao-field"}
      key={`hibrido-tipo-ligacao-field`}
      label={"* Tipo de Ligação"}
      textField="nome"
      prefix={<InputPrefix />}
      valueField="id"
      options={TIPO_LIGACAO_OPTIONS}
      disableClearable
      disabled={TIPO_LIGACAO_OPTIONS.length === 1}
      value={formState?.tipo_ligacao || null}
      renderOptions={(option: any) => {
        return `${option?.nome}`
      }}
      renderOptionsLabel={(option: any) => {
          return `${option?.nome}`
        }}
      onChange={(value) => {
        const payload: Partial<typeof formState> = { tipo_ligacao: value };

        onChangeValue(payload)
      }}
    />
  )
}